import { Component, OnInit, Injector } from '@angular/core';
import { BaseComponent } from 'common';
import { ActivatedRoute } from '@angular/router';
import { Showcase, ShowcaseProperty, ShowcasePropertyService } from 'api';

@Component({
  selector: 'app-showcase-details',
  templateUrl: './showcase-details.component.html',
  styleUrls: ['./showcase-details.component.scss']
})
export class ShowcaseDetailsComponent extends BaseComponent implements OnInit {
  showcase: Showcase;

  constructor(
    injector: Injector,
    private showcasePropertyService: ShowcasePropertyService,
    private route: ActivatedRoute
  ) {
    super(injector);
  }

  sendFeedback(showcaseProperty: ShowcaseProperty, status: string): void {
    showcaseProperty.status = status;
    this.showcasePropertyService.sendShowcasePropertyFeedback(
      this.route.snapshot.params['agency_uuid'],
      this.route.snapshot.params['uuid'],
      showcaseProperty
    ).then(response => showcaseProperty.status = response.status);
  }

  ngOnInit(): void {
    this.showcase = this.route.snapshot.data['showcase'];

    if (this.route.snapshot.queryParams['snapshot']) {
      this.showcase = this.showcase.showcase_snapshot_data;
    }
  }
}
